import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue, MapState } from '@gk/gk-modules';
import { BaseNewRequestFormService } from '../../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  PARLetterContentControlName,
  PARLetterDetailsControlName,
  PARNewRequestControlName,
  PARNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class PARNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup({
    isRequestTypeVisibe = false,
  }): FormGroup<PARNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(undefined, {
        addressFormGroupBasedOnSelectControls: true,
        disableAddressFormInNaturalPersonGroup: true,
      }).controls,
      [PARNewRequestControlName.Authority]: [getDefaultControlValue()],
      [PARNewRequestControlName.IsApplicantOwner]: [getDefaultControlValue()],
      [PARNewRequestControlName.ActType]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARNewRequestControlName.LetterContent]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARNewRequestControlName.LetterContentWithParcels]:
        this.formBuilder.array([]),
      [PARNewRequestControlName.OwnerId]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARNewRequestControlName.LetterDetails]: this.formBuilder.array([]),
      ...(isRequestTypeVisibe
        ? {
            [PARNewRequestControlName.RequestType]: [
              getDefaultControlValue(),
              [Validators.required],
            ],
          }
        : {}),
    });
  }

  getLetterContentWithParcelsFormGroup(mapState: MapState): FormGroup {
    return this.formBuilder.group({
      [PARLetterContentControlName.ActName]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARLetterContentControlName.IsAreaCoversAllParcels]: [
        getDefaultControlValue(),
      ],
      [PARLetterContentControlName.Content]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARLetterContentControlName.MapState]: mapState,
    });
  }

  getLetterDetailsFormGroup(mapState: MapState): FormGroup {
    return this.formBuilder.group({
      [PARLetterDetailsControlName.ActName]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARLetterDetailsControlName.IsAreaCoversAllParcels]: [
        getDefaultControlValue(),
      ],
      [PARLetterDetailsControlName.LandUseClass]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
      [PARLetterDetailsControlName.MaxBuildingCoverage]: [
        getDefaultControlValue(),
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      [PARLetterDetailsControlName.MaxBuildingHeight]: [
        getDefaultControlValue(),
        [Validators.required, Validators.min(0)],
      ],
      [PARLetterDetailsControlName.MinBiologicallyActiveArea]: [
        getDefaultControlValue(),
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      [PARLetterDetailsControlName.MapState]: mapState,
    });
  }
}
